import axios from "axios";

const endpoint_url = "/campaignV2/customer/options/presetTRParticipantsUnique";

const getPresetTRParticipantsUnique = async (params) => {
  return new Promise((resolve, reject) => {
    axios
      .get(endpoint_url, {
        params: {
          uuid: params.uuid,
        },
      })
      .then((response) => resolve(response))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

export default getPresetTRParticipantsUnique;
